import { CanActivateFn, ActivatedRouteSnapshot, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';

export const PermissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const perm = route.data?.['permission'] as string | undefined;
  if (!perm) return true;
  if (auth.hasPermission(perm)) return true;
  router.navigateByUrl('/');
  return false;
};
